<template>
  <div ref="top" class="top" style="background-size: cover">
    <layout-1
      v-if="layout == 1"
      ref="layout1"
      :openRole="openrole"
      v-model:chooseRoleId="chooseRoleId"
      :rolesList="rolesList"
      :openWebsite="openWebsite"
      :navData="navdata"
      :contentInfo="topData"
      :styleInfo="styleInfo"
      :checkObj="checkObj"
      :themeColor="themeColor"
      :activeTopMenu="activeTopMenu"
      :activeTopChildMenu="activeTopChildMenu"
      :isCustomDesk="isCustomDesk"
      :spaceAppen="spaceAppen"
      :upaceAppen="upaceAppen"
      :cloudAppen="cloudAppen"
      :adminload="adminload"
      :navPd="navPd"
      :registerconfig="registerconfig"
      :catchUser="catchUser"
      :isCollapse="isCollapse"
      :isAppenLi="isAppenLi"
      :customDeskInfo="customDeskInfo"
      @collapse="$emit('collapse',$event)"
      @to-login="openLoginInfo"
      @open-admin="openAdmin"
      @change-school="showSchoolDialog"
      @open-space="openChooseSpace"
      @change-role="showRoleDialog"
      @change-user="userVisiable = true"
      @on-logout="logout"
      @nav-click="$emit('nav-click', $event)"
      @change-top="$emit('change-top', $event)"
      @changeNav="$emit('changeNav',$event)"
    ></layout-1>  
    <layout-2
      v-else
      ref="layout2"
      :openRole="openrole"
      :openWebsite="openWebsite"
      v-model:chooseRoleId="chooseRoleId"
      :rolesList="rolesList"
      :navData="navdata"
      :contentInfo="topData"
      :styleInfo="styleInfo"
      :checkObj="checkObj"
      :themeColor="themeColor"
      :activeTopMenu="activeTopMenu"
      :activeTopChildMenu="activeTopChildMenu"
      :isCustomDesk="isCustomDesk"
      :spaceAppen="spaceAppen"
      :upaceAppen="upaceAppen"
      :cloudAppen="cloudAppen"
      :adminload="adminload"
      :navPd="navPd"
      :catchUser="catchUser"
      :registerconfig="registerconfig"
      :isCollapse="isCollapse"
      :customDeskInfo="customDeskInfo"
      @collapse="$emit('collapse',$event)"
      @nav-click="$emit('nav-click', $event)"
      @to-login="openLoginInfo"
      @open-admin="openAdmin"
      @change-school="showSchoolDialog"
      @open-space="openChooseSpace"
      @change-role="showRoleDialog"
      @on-logout="logout"
      @change-user="userVisiable = true"
      @change-top="$emit('change-top', $event)"
      @changeNav="$emit('changeNav',$event)"
    ></layout-2>
    <!-- 切换角色 -->
    <el-dialog
      title="请选择切换的门户"
      v-model="dialogFormVisible"
      width="500px"
      class="change-door"
    >
      <el-form>
        <el-radio-group v-model="currentChangeCustomId">
          <el-radio
            v-for="item in rolesList"
            :key="item.customDeskId"
            :label="'' + item.customDeskId"
            >{{ item.name }}</el-radio
          >
        </el-radio-group>
      </el-form>
      <div class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取消</el-button>
        <el-button type="primary" @click="changeRole">确定</el-button>
      </div>
    </el-dialog>
    <chooseSpace v-model:isView="isSpaceDia" :spaceList="spaceList"></chooseSpace>
    <!-- 更换单位 -->
    <el-dialog
      title="更换单位"
      v-model="dialogSchoolVisible"
      width="560px"
      :style="{ '--el-dialog-padding-primary': 0 }"
      class="change-door"
    >
      <div class="cont-school">
        <div class="inputArea">
          <el-input placeholder="请输入关键字搜索" :style="{ '--el-input-border-radius': '4px 0px 0px 4px' }" v-model="searchSchoolInput" clearable @blur="searchMoreFun" @input="searchMoreFun" @clear="resetSearch">
            <template #prefix>
              <i class="iconfont icon-sousuo"></i>
            </template>
          </el-input>
          <el-button size="small" @click="searchMoreFun" type="primary">
            <i class="iconfont icon-sousuo"></i>
          </el-button>
        </div>
        <div class="list-school" v-if="schoolList.length > 0">
          <el-scrollbar>
            <ul>
              <li
                v-for="item in schoolList"
                :key="item.schoolId"
                @click="changeSchool(item.schoolId)"
              >
                <div class="thumb">
                  <img :src="confilesRes($url + item.photo)" alt="" />
                </div>
                <div class="info">
                  <h6>{{ item.name }}</h6>
                  <p>{{ item.description }}</p>
                </div>
              </li>
            </ul>
          </el-scrollbar>
        </div>
      </div>
    </el-dialog>
    <loginInfo @getToken="getToken" loginStatus="keep" :loginMethod="loginMethod" @changeLoginStatus="changeLoginStatus" :registerconfig="registerconfig" :theme-color="themeColor" @close="closeLogin" v-model:isView="loginVisible" />
    <ChangeUser v-model:isView="userVisiable" />
    <vipPay v-model:isView="vipPayShow" />
  </div>
</template>

<script>
import { cloneDeep } from 'lodash'
import { signOut, xmssOut } from "@/api/utils";
import { emitter } from '@/util/util'
import { confilesRes } from "@/api/global.js";
import { adddefaultdesk, addspacedefaultdesk } from '@/port/common/schoolNews'
import { getschoolconfigs, isopenupace, getschool } from '@/port/admins/organizationSpace'
import { getuserspaces, getrolecustom, getcurrentusertip, getoutcustomdeskkey, getregisterusertemplate, getcustomdesk, getcustomdesklist, getcustomdeskkey } from '@/port/schoolInstrument/appConfig.js'
import { getcustomdesklist as getWebsitecustomdesklist, getcustomdesk as outgetcustomdesk } from '@/port/pages/webSite.js'
import { dealRolePermission } from '@/components/schoolInstrument/mixins/utils'
import ChangeUser from "./changeUser.vue";
import parmsMixins from '@/components/schoolInstrument/mixins/parmsMixins.js'
import { isConditionAppen } from '@/components/schoolInstrument/component/mutual/common/config.js'
import { getuserdesks, getuserspacedesks, getuserspaceroles, getuserroles, refreshaccesstoken, ixmlogout } from '@/port/schoolInstrument/appConfig'
import layout1 from './navigation/layout1.vue';
import layout2 from './navigation/layout2.vue';
import chooseSpace from './chooseSpace.vue';
import LoginInfo from '@/components/common/loginInfo.vue';
import { defineAsyncComponent } from 'vue';
export default {
  components: {
    layout1,
    layout2,
    chooseSpace,
    LoginInfo,
    ChangeUser,
    vipPay: defineAsyncComponent(() => import('@/components/common/vipPay/index')),
},
  props: {
    //- 当前导航栏展示模式：1：前台，2：后台
    typeShow: {
      type: Number,
      default: 1,
    },
    activeTopChildMenu: {
      type: Number,
      default: 0
    },
    activeTopMenu: {
      type: Number,
      default: 1
    },
    isCustomDesk: {
      type: Boolean,
      default:false
    },
    isOpenLogin: {
      type: Boolean,
      default: false
    },
    isCollapse: {
      type: Boolean,
      default: false
    },
    loginStatus: {
      type: String,
      default: 'keep'
    },
    loginMethod: {
      type: Number,
      default: 4
    },
    customDeskInfo: {
      type: Object,
      default: ()=>({})
    },
    isAppenLi: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isSpaceDia: false,
      // 导航栏布局
      layout: 1,
      topData: {},
      styleInfo: {},
      checkObj: { list: [] },
      // 暂存数据
      tem: null,
      dialogTitle: "请选择登录的角色",
      dialogFormVisible: false,
      dialogSchoolVisible: false,
      rolesList: [],
      chooseRoleId: '-1',
      //- 学校信息
      userMsg: null,
      schoolList: [],
      searchSchoolInput: '', //搜索关键字
      //- 学校id
      schoolId: "",
      openrole: true, //角色门户是否开启
      openWebsite: false, // 官网门户是否开启
      skey: '', // 官网加密字符串
      navdata: {}, //导航栏数据
      themeColor: null,
      fullscreenLoading: false,
      currentChangeCustomId: '-1',
      spaceid: this.$route.query.spaceid,
      upaceid: this.$route.query.upaceid,
      spaceList: [],
      spaceAppen: false,
      upaceAppen: false,
      cloudAppen: false,
      registerconfig: {}, // 外网登陆相关
      loginVisible: false,
      userVisiable: false,
      adminload: 0,
      navPd: 10,
      wxloginStatus: 'keep',
      openType: 'app',
      curInfo: {},
      catchUser: null,
      roleList: [],
      vipPayShow: false, //会员支付
    };
  },
  mixins: [parmsMixins],
  mounted () {
    //- 获取学校缓存消息
    let userMsg = localStorage.getItem("userMsg");
    if (userMsg) {
      this.userMsg = JSON.parse(userMsg);
      this.schoolId = this.userMsg.schoolMsg.schoolId;
      this.schoolList = this.userMsg.listschool;
      document.title = this.userMsg.schoolMsg.name;
    }
    this.getClientWidth()
    window.addEventListener('resize', this.getClientWidth)
    emitter.on('changeLoginStatus', this.changeLoginStatus)
    emitter.on('changeCustomData', async (val) => {
      const list = await this.changeCustomDataList(this.originalList, val)
      console.log(list,'listlistlist')
      this.checkObj.list = list
    })
    // 获取官网加密字符串
    this.skey = this.$route.params.skey || this.$route.query.skey || ''
    if (this.skey) {
      this.openWebsite = true
      this.getWebsiteConfig()
      emitter.on('10001-open-login', () => {
        this.loginVisible = true
      })
    } else {
      // 获取角色列表，个人空间不调用该接口
      if(!this.upaceid){
        this.getUserDesks();
      }
      else{
        this.$emit("changeDeskId", '-1');
        this.getConfig('-1');
      }
      this.getSpaceList()	
      this.getIsCloud()
      this.getCurSchoolInfo()
      this.getUpaceInfo()
      // 获取是否能去后台
      this.getcurrentusertip()
    }
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.getClientWidth)
  },
  watch: {
    loginStatus:{
      handler(val){
        this.wxloginStatus = val
      },
      immediate: true
    },
    styleInfo: {
      handler (val) {
        this.$emit('change-style-info', val)
      },
      deep: true
    },
    chooseRoleId(val) {
      // 如选择默认首页，则直接加载默认首页数据
      if (val === '-1') {
        this.$emit("changeDeskId", val);
        this.dialogFormVisible = false;
      }
      else {
        this.getConfig(val);
      }
    },
    isOpenLogin(val) {
      if (val) {
        this.openType = 'app'
        this.loginVisible = true
      }
    },
    $route: {
      handler(val) {
        if (val && val.params && val.params.skey) {
          this.skey = val.params.skey
          this.openWebsite = true
          this.getWebsiteConfig()
        }
      },
      deep: true
    },
  },
  computed: {
    handleIsMenu () {
      const model = {}
      if (this.activeTopChildMenu === 0) {
        this.checkObj.list.forEach(item => {
          if (item.id === this.activeTopMenu) {
            const info = item.layout
            if (info) {
              model.model = info.model.model
            }
          }
        })
      } else {
        this.checkObj.list.forEach(item => {
          item.lists.forEach(citem => {
            if (citem.id === this.activeTopChildMenu) {
              const info = citem.layout
              if (info) {
                model.model = info.model.model
              }
            }
          })
        })
      }
      return model.model === 'menu'
    }
  },
  methods: {
    async changeCustomDataList(list, customData) {
      if (!list) return []
      let li = list.filter(item => {
        let isView = item.isShow
        if (isView && item.condition) {
          isView = isConditionAppen(item.condition, {}, true, customData)
        }
        return isView
      })
      let user = localStorage.getItem('user')
      if (user && JSON.parse(user).isadmin >= 3) {
        li = await dealRolePermission({ val: li, roleList: this.roleList, children: 'lists'})
        li = li.filter(f => {
          if (f.lists) {
            f.lists = f.lists.filter(cf => !!cf.isPermissionAppen)
          }
          return !!f.isPermissionAppen
        })
      }
      return li
    },
    changeLoginStatus() {
      this.$refs[`layout${this.layout}`]?.getMessage()
      this.$emit('change-login-status')
    },
    getToken(val) {
      if (this.openType === 'nav') {
        this.$refs[`layout${this.layout}`].active(undefined, this.curInfo, val)
      } else {
        this.$emit('getToken', val)
      }
    },
    async setActiveNav(val) {
      // 父级用来改变导航
      const flag = await this.$refs[`layout${this.layout}`].active(undefined, val)
      return flag
    },
    getClientWidth() {
      const width = document.body.clientWidth
      if (this.$refs[`layout${this.layout}`]) {
        this.$refs[`layout${this.layout}`].changeScrollItem()
      }
      if (this.styleInfo.navbarAdaption === 'fixedSpacing') {
        this.navPd = 10
      } else {
        if (width <= 1200) {
          this.navPd = 6
        } else if (width > 1200 & width <= 1440) {
          this.navPd = 8
        } else {
          this.navPd = 10
        }
      }
    },
    closeLogin() {
      this.$emit('update:loginStatus', 'keep')
      this.$emit('update:loginMethod', 4)
      this.$emit('close-login')
    },
    async getcurrentusertip() {
      const res = await getcurrentusertip()
      if (res.code === 0) {
        this.adminload = res.data
      }
    },
    openLoginInfo(val) {
      if (val) {
        this.curInfo = val
        this.openType = 'nav'
        this.wxloginStatus = 'visitor'
      }
      this.loginVisible = true
    },
    async getLoginInfo(data) {
      const res = await getrolecustom(data)
      if (res.code === 0) {
        const registerconfig = typeof res.data.registerconfig === 'string' ? JSON.parse(res.data.registerconfig) : res.data.registerconfig
        this.registerconfig = registerconfig
        this.$store.commit('setRegisterConfig', registerconfig)
        // 替换页面title，并缓存
        document.title = res.data.name
        localStorage.setItem("webTitle", res.data.name);
      } else {
        this.$message.error(res.msg)
      }
    },
    // 判断是否显示组织空间
    async getCurSchoolInfo() {
      const { code, data, msg } = await getschoolconfigs()
      if (code === 0) {
        this.spaceAppen = data.space
        localStorage.setItem('schoolConfigs', data)
      } else {
        this.spaceAppen = false
        this.$message.error(msg)
      }
    },
    // 判断是否显示个人空间
    async getUpaceInfo() {
      const { code, data, msg } = await isopenupace()
      if (code === 0) {
        this.upaceAppen = data
      } else {
        this.upaceAppen = false
        this.$message.error(msg)
      }
    },
    // 判断是否显示网盘
    async getIsCloud() {
      const obj = {
        schoolId: this.schoolId
      }
      const { code, data, msg } = await getschool(obj)
      if (code === 0) {
        const { openstorage } = data
        this.cloudAppen = openstorage == 1 ? true : false
      } else {
        this.cloudAppen = false
        this.$message.error(msg)
      }
    },
    async getSpaceList() {
        try {
            const { code, data } = await getuserspaces()
            if (code === 0) {
                this.spaceList = data
            }
        } catch (error) {
            console.log(error);
        }
    },
    openChooseSpace() {
      if (this.spaceList.length === 1) {
        localStorage.setItem('spaceid', this.spaceList[0].organizationId)
        this.$openAdmin({ path: '/cust/main/spaceMain/home' }, { isNewTab: true })
        return
      }
      this.isSpaceDia = true
    },
    confilesRes (val) {
      return confilesRes(val);
    },
    // 获取用户所属的所有角色
    getUserDesks () {
      const that = this;
      const params = this.spaceid ? { spaceid: this.spaceid } : ''
      const fn = this.spaceid ? getuserspacedesks : getuserdesks
      fn(params).then((res) => {
        if (res && res.code === 0) {
          // 后台未开启角色门户
          if (res.data.openrole === false) {
            this.openrole = false;
            that.$emit("changeDeskId", '-1');
            that.getConfig('-1');
            return false;
          }
          if (res.data.list.length > 0) {
            that.rolesList = res.data.list;
            // 如未选择过角色，则弹窗让用户选择角色
            if (res.data.default === -1 && res.data.list.length > 1) {
              this.$emit('close-loading')
              this.dialogFormVisible = true
            } else {
              let stroageRoleid = null;
              if (res.data.list.length === 1) {
                stroageRoleid = res.data.list[0].customDeskId;
                this.chooseRoleId = '' + stroageRoleid;
              } else {
                const defaultId = res.data.default
                const idx = res.data.list.findIndex(c => c.customDeskId === defaultId)
                if (idx === -1) {
                  this.dialogFormVisible = true
                  this.$emit('close-loading')
                } else {
                  stroageRoleid = res.data.default;
                  // this.getConfig(stroageRoleid);
                  this.chooseRoleId = '' + stroageRoleid;
                }
              }
            }
          } else {
            that.$emit("changeDeskId", '');
            that.getConfig('');
          }
        } else {
          console.log("getuserroles 接口出错");
        }
      });
    },
    async getRolesList() {
      const params = this.spaceid ? { spaceid: this.spaceid } : ''
      const fn = this.spaceid ? getuserspaceroles : getuserroles
      const { data, code, msg } = await fn(params)
      if (code === 0) {
        this.roleList = data.list
      } else {
        this.$message.error(msg)
      }
    },
    // - 获取配置数据
    async getConfig (customDeskId) {
      const that = this;
      const path = this.$route.path
      this.fullscreenLoading = true
      this.$emit('loadingChange', true)
      let api = getcustomdesklist
      let _data;
      let deskkey = {}
      // 默认门户（场景页不提示）
      if (customDeskId === '' && !this.isCustomDesk) {
        if(path !== '/customInstrument'){
          this.$notify({
            title: "提示",
            message: "该门户模板未设计！",
            type: "warning",
          });
          this.$emit('close-loading')
        }
        return
      }
      if (customDeskId === '-1') {
        _data = {
          type: 0,
          curpage: 1,
          pagesize: 1,
          sence: 2
        }
        this.spaceid ? _data.spaceid = this.spaceid : ''
        this.upaceid ? _data.upaceid = this.upaceid : ''
      } else {
        // 角色门户
        api = getcustomdesk
        _data = {
          type: 4,
          curpage: 1,
          pagesize: 1,
          customDeskId: customDeskId || '',
          sence: 2
        }
        this.spaceid ? _data.spaceid = this.spaceid : ''
        this.upaceid ? _data.upaceid = this.upaceid : ''
      }
      if (this.isCustomDesk) {
        api = getcustomdesk
        _data = {
          type: 1,
          customDeskId: this.customDeskInfo.customDeskId || this.$route.query.customDeskId,
          sence: 2
        }
        this.spaceid ? _data.spaceid = this.spaceid : ''
        this.upaceid ? _data.upaceid = this.upaceid : ''
      }
      if (this.isCustomDesk || customDeskId !== '-1') {
        deskkey = await getcustomdeskkey(_data)
        if (deskkey.code !== 0) {
          this.loading = false
          this.$message.error(deskkey.msg)
          return
        }
      }
      await this.getRolesList()
      const keyone = deskkey.data
      api(_data, keyone).then(async (res) => {
        if (res && res.code === 0) {
          if (!res.data.content && customDeskId > 0) {
            // 角色没分配模板
            that.$notify({
              title: "提示",
              message: "该门户模板未设计！",
              type: "warning",
            });
            this.$emit('close-loading')
            return false;
          } else {
            if (res.data[0] ? res.data.length > 0 : Object.keys(res.data).length > 0) {
              const info = res.data[0] ? res.data[0].content ? JSON.parse(res.data[0].content) : '' : res.data.content ? JSON.parse(res.data.content) : ''
              if (info !== "") {
                if (info.customData && Array.isArray(info.customData)) {
                  await this.setParams(info, _data.customDeskId)
                }
                if (info.isCollapse !== undefined) {
                  this.$emit('collapse', info.isCollapse)
                }
                that.checkObj = cloneDeep(info.checkObj);
                if (info.checkObj.checked_home !== undefined) return
                const customData = this.$store.state.doorCustomDataObj[_data.customDeskId]
                this.originalList = info.checkObj.list
                let list = await this.changeCustomDataList(this.checkObj.list, customData)
                this.checkObj.list = list
                that.topData = info.styleTemp.topContentInfo;
                that.styleInfo = info.styleTemp.topStyle;
                that.layout = that.styleInfo.layout;
                that.themeColor = info.styleTemp.overAllStyle.themeColor;
                if (info.styleTemp.topContentInfo && info.styleTemp.topContentInfo.list && info.styleTemp.topContentInfo.list.navbar) {
                  this.$set(info.styleTemp.topContentInfo.list.navbar, 'list', list)
                }
                this.$emit("changeDeskId", this.chooseRoleId);
                that.$emit("headerInfo", info.styleTemp);
                // 单独龙岩做的
                if (localStorage.getItem('isLY')) {
                  const obj = {
                    1: 'layout1',
                    2: 'layout2'
                  }
                  this.$refs[obj[this.layout]] && this.$refs[obj[this.layout]].toLySpace()
                  localStorage.removeItem('isLY')
                }
                if (this.$route.path === '/index') {
                  const catchActive = sessionStorage.getItem('catchActive')
                  let infoItem = null
                  if (catchActive) {
                    // 加这段的意义是  由于在路由那边加上了key 所以每次点击的时候都会刷新页面 因此在这获取缓存的id  以至于点击的时候可以获取正确的id
                    const { isParent, id } = JSON.parse(catchActive)
                    for (const chi of this.checkObj.list) {
                      if (!isParent) {
                        for (const chiItem of chi.list) {
                          if (chiItem.id === id) {
                            infoItem = chi
                            break
                          }
                        }
                      }
                      if (chi.id === id) {
                        infoItem = chi
                        break
                      }
                    }
                  }
                  this.$emit('nav-click', infoItem || that.checkObj.list[0])
                  // this.$router.push('/index')
                }
                this.$emit('close-loading')
                this.fullscreenLoading = false
              } else {
                // 角色有分配模板，但是模板还没有设计
                if (customDeskId) {
                  that.$notify({
                    title: "提示",
                    message: "该门户模板未设计！",
                    type: "warning",
                  })
                }
                this.$emit('close-loading')
                this.fullscreenLoading = false
              }
            }
          }
        } else if (res.code === 8888){
          that.$message.error('您还未开通会员，请先开通');
          this.vipPayShow = true
        } else {
          console.log("getcustomdesklist 接口出错");
        }
        this.$emit('close-loading')
        this.fullscreenLoading = false
      });
    },

    // 官网获取配置
    getWebsiteConfig () {
      const that = this
      const data = {
        skey: this.skey
      }
      this.getLoginInfo(data)
      let fn = getWebsitecustomdesklist
      if (this.isCustomDesk) {
        fn = outgetcustomdesk
        data.customDeskId = this.$route.query.customDeskId
      }
      fn(data).then((res) => {
        if (res.code === 0) {
          const isArr = Array.isArray(res.data)
          let info = null
          if (isArr) {
            info = res.data[0].content ? JSON.parse(res.data[0].content) : null;
          } else {
            info = res.data.content ? JSON.parse(res.data.content) : null
          }
          if (info) {
            that.checkObj = info.checkObj;
            that.topData = info.styleTemp.topContentInfo;
            that.styleInfo = info.styleTemp.topStyle;
            that.layout = that.styleInfo.layout;
            that.themeColor = info.styleTemp.overAllStyle.themeColor;
            that.$emit("headerInfo", info.styleTemp);
          }
        } else {
          console.log('getcustomdesklist 接口出错')
        }
      })
    },
    //- 切换学校
    changeSchool (item) {
      let user = JSON.parse(localStorage.getItem("user"));
      user.apiurl = this.$apiurl;
      localStorage.setItem("user", JSON.stringify(user));
      this.fullscreenLoading = true;
      refreshaccesstoken({ schoolId: item }).then((res) => {
        if (res.code == 0) {
          this.userMsg.listschool.forEach((e) => {
            if (e.schoolId == item) {
              this.userMsg.schoolMsg = e;
              this.schoolId = item;
            }
          });
          localStorage.setItem("userMsg", JSON.stringify(this.userMsg));
          localStorage.setItem("user", JSON.stringify(res.data));
          this.$router.go(0);
          this.dialogSchoolVisible = false;
        } else {
          this.$alert("学校切换失败!", "提示", {
            confirmButtonText: "确定",
          });
        }
      });
    },
    // 后台管理
    openAdmin () {
      this.$openAdmin({ path: '/cust/main/home' }, { isNewTab: true });
    },
    // 切换学校弹层
    showSchoolDialog () {
      if (this.schoolList.length == 2) {
        for (let i = 0; i < this.schoolList.length; i++) {
          if (this.schoolList[i].schoolId != this.schoolId) {
            this.changeSchool(this.schoolList[i].schoolId);
            return;
          }
        }
      }
      else {
        this.dialogSchoolVisible = true;
      }
    },
    // 单位搜索
    searchMoreFun () {
      this.schoolList = this.userMsg.listschool;
      //并没有输入关键字时，就不要再搜索了
      if (this.searchSchoolInput === '' || this.searchSchoolInput == null) {
        this.schoolList = this.userMsg.listschool;
        return;
      }
      //搜索
      let list = this.schoolList.filter(item => item.name.indexOf(this.searchSchoolInput) >= 0);
      console.log(list);

      this.schoolList = list;
    },
    // 搜索重置
    resetSearch () {
      this.schoolList = this.userMsg.listschool;
    },
    // 切换角色弹层
    showRoleDialog () {
      // this.dialogTitle = "请选择切换的门户";
      // this.dialogFormVisible = true;
    },
    // 切换角色
    changeRole () {
      this.chooseRoleId = this.currentChangeCustomId
      const param = { customDeskId: this.currentChangeCustomId }
      if (this.spaceid) {
        param.spaceid = this.spaceid
        addspacedefaultdesk(param)
      } else if (this.upaceid) {
        param.upaceid = this.upaceid
        addspacedefaultdesk(param)
      } else {
        adddefaultdesk(param)
      }
      this.dialogFormVisible = false
    },
    //- 退出登录
    logout: function () {
      let _this = this;
      this.$confirm("确认退出吗?", {
        confirmButtonClass: "el-button--yeprimary",
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
          let userMsg = localStorage.getItem("userMsg");
          userMsg = JSON.parse(userMsg);
          if (this.$route.fullPath.includes('website')) {
            this.$refs[`layout${this.layout}`].clearSysUserMsg()
            if(this.$apiurl === 'https://xm.sszx.cn'){
              xmssOut()
            }
            return
          }
          const schoolId = userMsg.schoolMsg.schoolId
          const obj = { schoolId }
          if (this.spaceid || this.$route.query.spaceid) {
            obj.spaceid = this.spaceid || this.$route.query.spaceid
          }
          const res = await getoutcustomdeskkey(obj)
          if (res.code === 0) { 
            const skey = res.data
            if (skey) {
              const res1 = await getregisterusertemplate({skey})
              if (res1.code === 0) {
                signOut()
                  .then(() => {
                    this.$refs[`layout${this.layout}`].clearSysUserMsg()
                    if(this.$apiurl === 'https://xm.sszx.cn'){
                      xmssOut()
                    }
                    else{
                      this.$router.push(`/website/${skey}`)
                    }
                  })
                  .catch(error => {
                    console.error("登出失败：", error);
                  });
              } else {
                if (userMsg.ixmssoSessionId) {
                //- 说明是i厦门登录，退出需要走接口
                  _this.signLoginOut(userMsg.ixmssoSessionId);
                } else {
                  signOut()
                    .then(() => {
                      if(_this.$apiurl === 'https://xm.sszx.cn'){
                        xmssOut()
                      }
                      else{
                        _this.$router.push("/");
                      }
                    })
                    .catch(error => {
                      console.error("登出失败：", error);
                    });
                }
              }
            } else {
              if (userMsg.ixmssoSessionId) {
                //- 说明是i厦门登录，退出需要走接口
                _this.signLoginOut(userMsg.ixmssoSessionId);
              } else {
                signOut()
                  .then(() => {
                    if(_this.$apiurl === 'https://xm.sszx.cn'){
                      xmssOut()
                    }
                    else{
                      _this.$router.push("/login");
                    }
                  })
                  .catch(error => {
                    console.error("登出失败：", error);
                  });
              }
            }
          }
        })
        .catch(() => { });
    },
    //- 退出登录
    signLoginOut (ixmssoSessionId) {
      const that = this;
      ixmlogout({ ssoSessionId: ixmssoSessionId }).then(() => {
        signOut()
          .then(() => {
            if(that.$apiurl === 'https://xm.sszx.cn'){
              xmssOut()
            }
            else{
              that.$router.push("/login");
            }
          })
          .catch(error => {
            console.error("登出失败：", error);
          });
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../schoolInstrument/component/roll/css/other.css";
::v-deep .el-scrollbar__wrap {
  overflow-x: hidden !important;
}
::v-deep .el-dialog.change-door {
  border-radius: 4px;
  .el-dialog__header {
    height: 52px;
    line-height: 52px;
    padding: 0 20px;
    border-bottom: 1px solid #d8d8d8;
    .el-dialog__title {
      font-size: 16px;
      color: #6a6a6a;
    }
    .el-dialog__headerbtn {
      right: 15px;
      top: 4px;
      font-size: 20px;
      color: #bfbfbf;
    }
  }
  .el-dialog__body {
    padding: 0;
    .dialog-footer {
      display: flex;
      justify-content: end;
      padding: 10px;
      height: 30px;
      border-top: 1px solid #d8d8d8;
      .el-button {
        width: 63px;
        height: 30px;
        padding: 0;
        text-align: center;
      }
    }
  }
}

.list-school {
  height: 464px;
  overflow: hidden;
  ul {
    display: flex;
    flex-flow: wrap;
    align-items: center;
    justify-content: space-between;
    li {
      width: 100%;
      height: 44px;
      padding: 12px 15px 11px;
      margin: 5px 0;
      overflow: hidden;
      box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.14);
      border-radius: 4px;
      transition: all 0.3s;
      cursor: pointer;
      .thumb {
        float: left;
        width: 44px;
        height: 44px;
        overflow: hidden;
        border-radius: 50%;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .info {
        float: left;
        width: 430px;
        padding-left: 10px;
        color: #333333;
        h6 {
          height: 22px;
          font-size: 16px;
          font-weight: 400;
          line-height: 22px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        p {
          margin-top: 5px;
          height: 17px;
          font-size: 12px;
          font-weight: 400;
          line-height: 17px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
      &:hover {
        box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.4);
      }
    }
  }
}
.el-form {
  line-height: 41px;
  padding: 10px 20px;
}
.el-radio {
  padding: 10px 0;
}

::v-deep .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #333333;
}
::v-deep .el-popover {
  height: 303px;
  overflow: hidden scroll;
}
.headerContent {
  width: 100%;
  position: relative;
  display: inline-block;
  height: 100%;
}
.cont-school {
  padding: 10px 0;
  .inputArea {
    padding: 0 20px;
    display: flex;
    align-items: center;
    line-height: 32px;
    ::v-deep .el-input__inner {
      border-right: none;
      border-radius: 4px 0 0 4px;
    }
    ::v-deep .el-button {
      width: 60px;
      height: 32px;
      background-color: #4e86ff;
      border: 1px solid #4e86ff;
      border-radius: 0 4px 4px 0;
      padding: 0;
      .iconfont {
        font-size: 24px;
      }
    }
  }
  ::v-deep .el-scrollbar {
    width: 100%;
    height: 100%;
  }
  ::v-deep .el-scrollbar__wrap {
    overflow-y: scroll;
    overflow-x: hidden;
    .el-scrollbar__view {
      padding: 5px 20px 0;
    }
  }
}
</style>
